import {
    DashboardFull,
    NewsFull,
    ProductsCatalogFull,
    TablesFull,
    ParametresFull,
    CalendarFull,
    SaisiesFull,
    OrdersListFull,
    CustomersListFull,
    TraitementFull,
    ShopsSettingsFull,
    Warning
} from '@icons';

export const pageTitles: Record<
    string,
    {
        title?: string;
        subtitle?: string;
        welcome?: boolean;
        icon?: React.ReactNode;
    }
> = {
    /* Member Management */
    '/members-management': {
        icon: <DashboardFull />,
        title: 'Tableau de bord',
        welcome: true
    },
    '/members-management/members': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Liste adhérents'
    },
    '/members-management/members/edition': {
        icon: <TraitementFull />,
        title: 'Traitement',
        subtitle: 'Édition adhérents'
    },
    '/members-management/members/:id/details': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Fiche adhérent'
    },
    '/members-management/members/:id/details/:tab': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Fiche adhérent'
    },
    '/members-management/members/add': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Créer un nouvel adhérent'
    },
    '/members-management/members/:id/edit': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Modifier un adhérent'
    },
    '/members-management/bookings': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Liste réservations'
    },
    '/members-management/apartments': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Liste logements'
    },
    '/members-management/apartments/edition': {
        icon: <TraitementFull />,
        title: 'Traitement',
        subtitle: 'Planning logements'
    },
    '/members-management/apartments/add': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Créer un nouveau logement'
    },
    '/members-management/apartments/:id/edit': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Modifier un logement'
    },
    '/members-management/apartments/:id/details/:tab': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Fiche logement'
    },
    '/members-management/apartments/:id/details': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Fiche logement'
    },
    '/members-management/apartments/:id/bookings/add': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Créer une réservation'
    },
    '/members-management/apartments/:id/bookings/:bookingId/edit': {
        icon: <TablesFull />,
        title: 'Tables',
        subtitle: 'Modifier une réservation'
    },
    '/members-management/settings/:tab': {
        icon: <ParametresFull />,
        title: 'Paramètres',
        subtitle: 'Edition paramètres'
    },
    '/members-management/settings': {
        icon: <ParametresFull />,
        title: 'Paramètres',
        subtitle: 'Edition paramètres'
    },
    '/members-management/ticketings': {
        icon: <SaisiesFull />,
        title: 'Saisies',
        subtitle: 'Suivi billetterie'
    },
    '/members-management/ticketings/edition': {
        icon: <TraitementFull />,
        title: 'Traitement',
        subtitle: 'Édition billetterie'
    },
    '/members-management/contributions/edition': {
        icon: <TraitementFull />,
        title: 'Traitement',
        subtitle: 'Édition cotisations'
    },
    '/members-management/financial-benefits/edition': {
        icon: <TraitementFull />,
        title: 'Traitement',
        subtitle: 'Édition prestations financières'
    },
    '/members-management/social-benefits/edition': {
        icon: <TraitementFull />,
        title: 'Traitement',
        subtitle: 'Édition prestations sociales'
    },
    '/members-management/etiquettes/edition': {
        icon: <TraitementFull />,
        title: 'Traitement',
        subtitle: 'Édition étiquettes RTC'
    },
    '/members-management/ticketings/add': {
        icon: <SaisiesFull />,
        title: 'Saisies',
        subtitle: 'Vente billetterie'
    },
    '/members-management/ticketings/add-multi': {
        icon: <SaisiesFull />,
        title: 'Saisies',
        subtitle: 'Vente billetterie'
    },
    '/members-management/ticketings/:id/edit': {
        icon: <SaisiesFull />,
        title: 'Saisies',
        subtitle: 'Modification billetterie'
    },
    '/members-management/subscriptions': {
        icon: <TablesFull />,
        title: 'Saisies',
        subtitle: 'Importation des cotisations'
    },
    /* Product Management */
    '/products-management': {
        icon: <DashboardFull />,
        title: 'Tableau de bord',
        welcome: true
    },
    '/products-management/orders': {
        icon: <OrdersListFull />,
        title: 'Commandes',
        subtitle: 'Liste commandes'
    },
    '/products-management/orders/:id/details': {
        icon: <OrdersListFull />,
        title: 'Commandes',
        subtitle: 'Fiche commande'
    },
    '/products-management/customers': {
        icon: <CustomersListFull />,
        title: 'Clients',
        subtitle: 'Liste clients'
    },
    '/products-management/products': {
        icon: <ProductsCatalogFull />,
        title: 'Catalogue produit',
        subtitle: 'Liste produits'
    },
    '/products-management/products/add': {
        icon: <ProductsCatalogFull />,
        title: 'Catalogue produit',
        subtitle: 'Création fiche produit'
    },
    '/products-management/products/:id/edit': {
        icon: <ProductsCatalogFull />,
        title: 'Catalogue produit',
        subtitle: 'Modification fiche produit'
    },
    '/products-management/news': {
        icon: <NewsFull />,
        title: 'Actualités',
        subtitle: 'Liste actualités'
    },
    '/products-management/news/:id/edit': {
        icon: <NewsFull />,
        title: 'Actualités',
        subtitle: 'Modification actualité'
    },
    '/products-management/news/add': {
        icon: <NewsFull />,
        title: 'Actualités',
        subtitle: 'Nouvelle actualité'
    },
    '/products-management/:id/duplicate': {
        icon: <NewsFull />,
        title: 'Actualités',
        subtitle: 'Nouvelle actualité'
    },
    '/products-management/agenda': {
        icon: <CalendarFull />,
        title: 'Agenda',
        subtitle: 'Liste événements'
    },
    '/products-management/settings/:tab': {
        icon: <ShopsSettingsFull />,
        title: 'Paramètres boutique',
        subtitle: 'Edition'
    },
    '/products-management/settings': {
        icon: <ShopsSettingsFull />,
        title: 'Paramètres boutique',
        subtitle: 'Edition'
    },
    '/products-management/flash-infos': {
        icon: <Warning />,
        title: 'Info flash',
        subtitle: 'Liste info flash'
    },
    '/products-management/flash-infos/:id/edit': {
        icon: <Warning />,
        title: 'Info flash',
        subtitle: 'Modification info flash'
    },
    '/products-management/members-validation': {
        icon: <CustomersListFull />,
        title: 'Validation adhérents',
        subtitle: 'Liste validations'
    },
    '/products-management/members-validation/:id/edit': {
        icon: <CustomersListFull />,
        title: 'Validation adhérents',
        subtitle: 'Modification validation'
    }
};
